import type { FC } from 'react';
import type { DeviceType } from '../agent';
import { useOnVisible } from '../hooks/useOnVisible';
import { PRISTIPS_URL, withReferralSource } from '../pristips/constants';
import { CARD_SHELL_CLASSNAME } from '../pristips/dimensions';
import { trackClickPristips, trackViewPristips } from '../utils/tracking';
import { CardAction } from './CardAction';

interface Props {
    squareMeterPrice: number | null;
    deviceType: DeviceType;
}

const formatPrice = (price: number) => `${new Intl.NumberFormat('nb-NO').format(price)} kr`;

export const PristipsCard: FC<Props> = ({ squareMeterPrice, deviceType }) => {
    const cardRef = useOnVisible<HTMLAnchorElement>(trackViewPristips);
    const hasSquareMeterPrice = squareMeterPrice !== null;

    return (
        <a
            ref={cardRef}
            className={`${CARD_SHELL_CLASSNAME} flex flex-col s-bg-subtle pt-16 px-16 pb-[72px]`}
            href={withReferralSource(PRISTIPS_URL)}
            target={deviceType === 'desktop' ? '_blank' : '_top'}
            rel="noopener noreferrer"
            onClick={trackClickPristips}
            onAuxClick={(e) => {
                if (e.button === 1) trackClickPristips();
            }}
        >
            {hasSquareMeterPrice && (
                <div className="flex flex-col">
                    <p className="text-s s-text-subtle">Kvadratmeterpris i området:</p>
                    <span className="text-l font-bold s-text-link">{formatPrice(squareMeterPrice)}</span>
                </div>
            )}

            <p className="text-l font-bold s-text">Hva er boligen din verdt?</p>
            {!hasSquareMeterPrice && (
                <p className="text-s s-text-subtle">Få et raskt estimat basert på salg i ditt område med Pristips.</p>
            )}

            <CardAction className="s-bg-primary hover:s-bg-primary-hover s-text-inverted">Se Pristips</CardAction>
        </a>
    );
};
